import { call, put, takeEvery } from 'redux-saga/effects';
import { message } from 'antd';
import { generateUserAPIToken } from '../../requests/generate_user_api_token.request';
import { generateUserAPITokenSuccess, generateUserAPITokenFailure } from '../actions/generate_user_api_token.actions';
import { GENERATE_USER_API_TOKEN } from '../constants/generate_user_api_token.constants';

function* generateUserAPITokenReq({ data }) {
    const response = yield call(generateUserAPIToken, data);

    if (response.result) {
        yield put(generateUserAPITokenSuccess(response.options));
        message.success('API token generated successfully');
    } else {
        message.error('Error with generate API token');
        yield put(generateUserAPITokenFailure(response.error));
    }
}

export default function* generateUserAPITokenSaga() {
    yield takeEvery(GENERATE_USER_API_TOKEN, generateUserAPITokenReq);
}



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/sagas/generate_user_api_token.saga.js